import React from "react";
import ErrorPng from "../assests/wrong.webp";
import ErrorIcon from "../assests/errorIcon.jpg";
import ReportIcon from "@mui/icons-material/Report";

const Error = ({ ErrorMessage }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textalign: "center",
        height: "90vh",
        width: "100vw",
        fontSize: "20px",
        fontWeight: "600",
      }}
    >
      {ErrorMessage === "loading" || !ErrorMessage ? (
        <>
          <ReportIcon sx={{ fontSize: "20rem", color: "red" }} />
          Oops! Somthing Went Wrong....
        </>
      ) : (
        <>
          <ReportIcon sx={{ fontSize: "20rem", color: "red" }} />
          {ErrorMessage}
        </>
      )}
    </div>
  );
};

export default Error;
